module.exports = __webpack_public_path__ + "img/alarm.7e60d05e.png";